import { usePagesInfiniteQuery } from "@/react/components/SettingsApp/Site/Pages/hooks/usePagesInfiniteQuery";

interface UsePublishedPagesOptions {
  shouldFilterRestrictedPages?: boolean;
}

export const usePublishedPages = ({
  shouldFilterRestrictedPages = false,
}: UsePublishedPagesOptions = {}) => {
  const { data, isLoading, error } = usePagesInfiniteQuery({
    initialPage: 1,
    perPage: 1000,
    query: "",
    status: "published",
  });

  const pages = data?.pages.flatMap(page => page.records) ?? [];

  const filteredPages = shouldFilterRestrictedPages
    ? pages.filter(
        page =>
          // Only include pages that are truly open/public for lockscreens
          !page.setting?.password_protection_enabled &&
          page.setting?.access_type === "open_access",
      )
    : pages;

  return {
    pages: filteredPages,
    isLoading,
    error,
  };
};
